"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _misc = require("../utils/misc");

var _constants = require("../constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var isTimestampExpired = function isTimestampExpired(timestamp) {
  var elapsedMilliseconds = Date.now() - timestamp;
  return elapsedMilliseconds > _constants.VIEW_PREVIOUS_CACHE_TIMEOUT;
};

var isViewMissingRequiredFields = function isViewMissingRequiredFields(view) {
  if (!view.experience && !view.property && !view.view_name) {
    return true;
  }

  return false;
};

var ViewPreviousCache = /*#__PURE__*/function () {
  function ViewPreviousCache() {
    (0, _classCallCheck2["default"])(this, ViewPreviousCache);
    (0, _defineProperty2["default"])(this, "_cachedView", void 0);

    if ((0, _misc.noWindow)()) {
      return;
    }

    try {
      var rawCachedValue = window.localStorage.getItem(_constants.VIEW_PREVIOUS_CACHE_KEY);
      var parsedView = JSON.parse(rawCachedValue);
      var timestampMs = parseInt(parsedView.cacheTimestamp);

      if (!isTimestampExpired(timestampMs)) {
        this._cachedView = _objectSpread(_objectSpread({}, parsedView), {}, {
          cacheTimestamp: new Date(timestampMs)
        });
      }
    } catch (e) {}
  }

  (0, _createClass2["default"])(ViewPreviousCache, [{
    key: "saveToBrowser",
    value: function saveToBrowser() {
      if (this._cachedView) {
        var serializedView = JSON.stringify(_objectSpread(_objectSpread({}, this._cachedView), {}, {
          cacheTimestamp: this._cachedView.cacheTimestamp.valueOf()
        }));
        window.localStorage.setItem(_constants.VIEW_PREVIOUS_CACHE_KEY, serializedView);
      }
    }
  }, {
    key: "get",
    value: function get() {
      if (this._cachedView) {
        var view = _objectSpread({}, this._cachedView);

        delete view.cacheTimestamp;

        if (isViewMissingRequiredFields(view)) {
          return undefined;
        }

        return view;
      }

      return undefined;
    }
  }, {
    key: "update",
    value: function update(view) {
      if ((0, _misc.noWindow)() || !view || isViewMissingRequiredFields(view)) {
        return;
      }

      var timestampedView = _objectSpread(_objectSpread({}, view), {}, {
        cacheTimestamp: new Date()
      });

      delete timestampedView.content;
      this._cachedView = timestampedView;
      this.saveToBrowser();
    }
  }]);
  return ViewPreviousCache;
}();

var _default = ViewPreviousCache;
exports["default"] = _default;